module.exports = __webpack_public_path__ + "static/media/Unfezant_gaussian2.614a7f20.png";